import { render, staticRenderFns } from "./discussForm.vue?vue&type=template&id=7eea630a&scoped=true"
import script from "./discussForm.vue?vue&type=script&lang=js"
export * from "./discussForm.vue?vue&type=script&lang=js"
import style0 from "./discussForm.vue?vue&type=style&index=0&id=7eea630a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eea630a",
  null
  
)

export default component.exports